<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { ref } from "vue";
import { useForm, Link } from '@inertiajs/vue3';
import Loading from 'vue-loading-overlay';

const props = defineProps({
    year: String,
    countries: Object,
    flash: Object,
    user: Object,
});
let isLoading = ref(false);
let cities = ref([]);

const handleCountryChange = (e) => {
    const country_id = e.target.value;
    const country = props.countries.find((item) => item.id == country_id);
    cities.value = country.cities;
    AgentAddform.city_id = cities.value.sort((a, b) => a.name.localeCompare(b.name))[0].id;
    isLoading.value = true;
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
};

const AgentAddform = useForm({
    agency_name: '',
    agency_telephone: '',
    agency_mobile: '',
    agency_email: '',
    agency_address: '',
    country_id: '',
    city_id: '',
    agency_TIN: '',
    pan_number: '',
    agent_logo: null,
    company_id: '1',
    active: '1',
});

const AgentAddformSubmit = () => {
    AgentAddform.post('/agents/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
};

</script>
<style scoped>
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Create Agent" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="card mb-4">
                <h5 class="card-header">Create Agent <span class="badge bg-label-warning"></span>
                </h5>
                <form class="card-body" @submit.prevent="AgentAddformSubmit">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Agency Name</b></label>
                            <input type="text" class="form-control" placeholder="Agency Name"
                                v-model="AgentAddform.agency_name"
                                :class="{ 'is-invalid': AgentAddform.errors.agency_name }" required>
                            <div v-if="AgentAddform.errors.agency_name" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.agency_name">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Contact No 1</b></label>
                            <input type="text" class="form-control" placeholder="Contact Number 1"
                                v-model="AgentAddform.agency_telephone"
                                :class="{ 'is-invalid': AgentAddform.errors.agency_telephone }">
                            <div v-if="AgentAddform.errors.agency_telephone" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.agency_telephone">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Contact No 2</b></label>
                            <input type="text" class="form-control" placeholder="Contact Number 2"
                                v-model="AgentAddform.agency_mobile">
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>Email</b></label>
                            <input type="text" class="form-control" placeholder="Email Address"
                                v-model="AgentAddform.agency_email"
                                :class="{ 'is-invalid': AgentAddform.errors.agency_email }">
                            <div v-if="AgentAddform.errors.agency_email" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.agency_email">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>TIN</b></label>
                            <input type="text" class="form-control" placeholder="TIN Number"
                                v-model="AgentAddform.agency_TIN" :class="{ 'is-invalid': AgentAddform.errors.agency_TIN }">
                            <div v-if="AgentAddform.errors.agency_TIN" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.agency_TIN">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label for="meal_type" class="form-label"><b>PAN Number</b></label>
                            <input type="text" class="form-control" placeholder="PAN Number"
                                v-model="AgentAddform.pan_number" :class="{ 'is-invalid': AgentAddform.errors.pan_number }">
                            <div v-if="AgentAddform.errors.pan_number" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.pan_number">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="hotel_image" class="col-form-label"><b>Agency Logo </b></label>
                            <input type="file" class="form-control"
                                @input="AgentAddform.agent_logo = $event.target.files[0]"
                                :class="{ 'is-invalid': AgentAddform.errors.agent_logo }">
                            <progress v-if="AgentAddform.progress" :value="AgentAddform.progress.percentage" max="100">
                                {{ AgentAddform.progress.percentage }}%
                            </progress>
                            <div v-if="AgentAddform.errors.agent_logo" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.agent_logo">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="hotel_id" class="form-label"><b>Country</b></label>
                            <select class="form-select" v-model="AgentAddform.country_id"
                                :class="{ 'is-invalid': AgentAddform.errors.country_id }" @change="handleCountryChange">
                                <option value="" disabled="disabled" selected="selected">Select a country ...</option>
                                <option v-for="countries in props.countries" :value="countries.id">
                                    {{ countries.name }}</option>
                            </select>
                            <div v-if="AgentAddform.errors.country_id" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.country_id">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="city_id" class="form-label"><b>City</b></label>
                            <select class="form-select" name="city_id" v-model="AgentAddform.city_id"
                                :class="{ 'is-invalid': AgentAddform.errors.city_id }">
                                <option value="" disabled="disabled" selected="selected">Select a city ...</option>
                                <option v-for="city in cities" :key="city.id" :value="city.id">
                                    {{ city.name }}</option>
                            </select>
                            <div v-if="AgentAddform.errors.city_id" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.city_id">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="meal_type" class="form-label"><b>Agency Address</b></label>
                            <textarea name="collapsible-address" class="form-control" v-model="AgentAddform.agency_address"
                                rows="2" placeholder="Agency Address"
                                :class="{ 'is-invalid': AgentAddform.errors.agency_address }"></textarea>
                            <div v-if="AgentAddform.errors.agency_address" class="invalid-feedback">
                                <div v-text="AgentAddform.errors.agency_address">
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="my-4 mx-n4">
                    <div class="modal-footer border-0 mt-3">
                        <Link type="button" class="btn btn-label-secondary" :href="'/agents'">
                        Cancel
                        </Link>
                        <button type="submit" class="btn btn-primary me-sm-3 me-1"
                            :disabled="AgentAddform.processing">Create
                            Agent</button>
                    </div>
                </form>
            </div>
        </div>
    </AppLayout>
</template>